<template>
  <v-dialog v-model="display" width="600" persistent scrollable :fullscreen="$vuetify.breakpoint.xs" :transition="$vuetify.breakpoint.xs ? `dialog-bottom-transition` : `dialog-transition`" :content-class="$vuetify.breakpoint.xs ? `safe-area-padding-top-dialog` : `safe-area-padding-top safe-area-padding-bottom`">
    <v-card class="dialog-group-responses p-relative overflow-hidden white--text primary" :class="$vuetify.breakpoint.xs ? `dialog-fullscreen` : ``" rounded="lg">
      <hub-app-bar :title="`Question Response`" hide-title color="primary" persistent dialog>
        <template slot="actions-left">
          <v-btn color="secondary" class="flex-shrink-1 flexk-grow-1 text-capitalize" text v-text="`Close`" dark @click="close" />
        </template>
        <template slot="actions-right">
          <v-btn color="secondary" class="flex-shrink-1 flexk-grow-1 text-capitalize" text v-text="`View`" dark @click="openContent" />
        </template>
      </hub-app-bar>
      <v-card-text class="pa-4 text-body-2 white--text">
        <p class="text-body-1 text-center text-pre-line" v-if="question" v-html="question"></p>
        <v-divider dark v-if="question" />
        <v-list two-line color="transparent" dark v-if="answer">
          <v-list-item class="px-0" dense>
            <v-list-item-content>
              <p class="text-caption ml-3 primary--text text--lighten-5">{{ userFullName || "The Hub User" }}</p>
              <v-card color="primary lighten-1 px-3 py-2 text-body-2 text-pre-line" rounded="lg" v-html="answer"> </v-card>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <p v-else class="py-8 text-center">This is where you can view the group response, there are no responses submitted yet. Open this page again to see the latest responses.</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import HubAppBar from "@/components/HubAppBar.vue";

export default {
  components: {
    HubAppBar
  },
  props: {
    groupId: String,
    contentId: String,
    questionId: String,
    questionText: String
  },
  data() {
    return {
      display: false,
      loading: true,
      question: "",
      answer: "",
      screenId: "",
      userFullName: "",
      idContent: "",
      idContentShare: "",
      idGroup: ""
    };
  },
  computed: {

  },
  methods: {
    open({question = "", answer = "", screenId = "", userFullName = "", idContent, idContentShare, idGroup} = {}) {
      this.display = true;

      this.question = question || "";
      this.answer = answer || "";
      this.screenId = screenId || "";
      this.userFullName = userFullName || "";
      this.idContent = idContent || "";
      this.idContentShare = idContentShare || "";
      this.idGroup = idGroup || "";

      this.display = true;
    },
    openContent() {
      if(this.idContentShare && this.idGroup) {
        this.$router.push({
          name: "main.feed.content.viewer",
          params: {id: this.idContentShare},
          query: {
            groupId: this.idGroup,
            screen: this.screenId
          },
        });
      }

      this.close();
    },
    close() {
      this.display = false;
    },
  },
};
</script>
